import { Component, Input, OnChanges } from '@angular/core';
import { PHOTO_REVIEW_UISTATE } from '../../model/photo-review.constant';
import { PhotoUtilsService } from '../../service/photo-review-utils.service';
import { GalleryOptions } from '@cv-invision/cv.component-library.ux';

@Component({
	selector: 'cv-photo-content-interior',
	templateUrl: './photo-content-interior.component.html',
	styleUrls: ['../photo-content-detail.component.scss']
})
export class PhotoContentInteriorComponent implements OnChanges {
	noInfo = PHOTO_REVIEW_UISTATE.NO_INFO;
	@Input() info: any;
	@Input() galleryOptions: any;
	constructor(private photoUtils: PhotoUtilsService) { }

	options: GalleryOptions = {
		hasSelected: false,
		showDescription: false,
		noFilesImage: 'assets/img/placeholder/nofiles.png',
		size: {
			width: '100%',
			height: '225px'
		}
	}

	ngOnChanges(): void {
		if (this.info) {
			this.info.forEach(i => {
				if (i.cv_photos) {
					i.cv_photos = this.photoUtils.setGalleryPhotosInfo(i.cv_photos);
				}
			});
		}
	}
}
